import { ErrorHandler } from '@angular/core';
import { FirebaseX } from "@ionic-native/firebase-x/ngx";
import { Platform } from '@ionic/angular';
import * as stacktrace from "stacktrace-js";
import * as Sentry from '@sentry/browser';
import * as i0 from "@angular/core";
import * as i1 from "@ionic-native/firebase-x/ngx/index";
import * as i2 from "@ionic/angular";
export class AppErrorHandler {
    constructor(firebase, platform) {
        this.firebase = firebase;
        this.platform = platform;
        this.Tag = "AppErrorHandler";
    }
    handleError(error) {
        const handledError = error && (error.originalError || error);
        console.error(handledError);
        try {
            Sentry.captureException(handledError);
        }
        catch (e) {
            // no-op if Sentry not initialized
        }
        if (this.platform.is("cordova")) {
            stacktrace.get().then(trace => this.firebase.logError(this.Tag + " | Error => " + handledError + " | Trace =>" + trace));
        }
    }
}
AppErrorHandler.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AppErrorHandler_Factory() { return new AppErrorHandler(i0.ɵɵinject(i1.FirebaseX), i0.ɵɵinject(i2.Platform)); }, token: AppErrorHandler, providedIn: "root" });
